// stores/favoritesStore.ts
import { create } from 'zustand';
// @ts-ignore
import Cookies from 'js-cookie';

type FavoriteItem = {
  id: string; // or whatever uniquely identifies your items
  [key: string]: any; // additional properties
};

interface FavoritesState {
  favorites: number[];
  addFavorite: (item: FavoriteItem) => void;
  removeFavorite: (id: string) => void;
  loadFavoritesFromCookies: () => void;
}

const FAVORITES_COOKIE_KEY = 'user_favorites';

const useFavoritesStore = create<FavoritesState>((set, get) => ({
  favorites: [],

  addFavorite: (item) => {
    const updatedFavorites = [...get().favorites, item];
    // @ts-ignore
    set({ favorites: updatedFavorites });
    Cookies.set(FAVORITES_COOKIE_KEY, JSON.stringify(updatedFavorites));
  },

  removeFavorite: (id) => {
    // @ts-ignore
    const updatedFavorites = get().favorites.filter((item) => item !== id);
    set({ favorites: updatedFavorites });
    Cookies.set(FAVORITES_COOKIE_KEY, JSON.stringify(updatedFavorites));
  },

  loadFavoritesFromCookies: () => {
    const cookieFavorites = Cookies.get(FAVORITES_COOKIE_KEY);
    if (cookieFavorites) {
      set({ favorites: JSON.parse(cookieFavorites) });
    }
  },
}));

export default useFavoritesStore;
